import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { auth, db } from '../firebase';
import moment from 'moment'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserSlash, faUserTie, faTools, faTimes, faBook } from "@fortawesome/free-solid-svg-icons";

export default class Header extends Component {
  constructor (props) {
    super(props);

    this.state = {
      email: "matsuyama@techfund.jp",
      notifications: [],
      dropdownmenu: "hide"
    };
  }

  componentDidMount () {
    // ログイン確認
    var scope = this
    auth.onAuthStateChanged(function(user) {
      if (user) {
      	scope.setState({email: auth.currentUser.email})
        db.ref('notifications').orderByChild("delete").equalTo(null).on('value', snapshot => {
          var notif = snapshot.val()
          var notifications = []
          for (let i in notif) {
            notifications.push({id: i, title: notif[i].title, body: notif[i].body, createdAt: notif[i].createdAt, cross: notif[i].cross})
          }
          scope.setState({ notifications: notifications })
        });
      }
    });
  }

  dropdown () {
    if (this.state.dropdownmenu === "hide") {
      this.setState({dropdownmenu: "show"})
    } else {
      this.setState({dropdownmenu: "hide"})
    }
  }

  rePassword () {
    auth.sendPasswordResetEmail(auth.currentUser.email);
    db.ref("notifications").push({title: "パスワード変更メールが送付されました。", createdAt: Date.now(), cross: true});
  }

  notificationDelete (key) {
    db.ref("notifications/" + key).update({delete: 1});
  }

  logout () {
    auth.onAuthStateChanged((user) => {
      auth.signOut().then(()=>{
        window.location.href = "/admin_login"
      })
      .catch( (error)=>{
        console.log(`ログアウト時にエラーが発生しました (${error})`);
      });
    });
  }

  render () {
    const notification_list = this.state.notifications.map(notification => {
      let notification_delete
      if (notification.cross) {
        notification_delete = <span className="notification-delete" onClick={e => this.notificationDelete(notification.id)}><FontAwesomeIcon icon={faTimes} /></span>
      }
      return <li><span className="notification-date">{moment(notification.createdAt).format('YYYY/MM/DD')}</span><span className="notification-title">{notification.title}</span>{notification.body}{notification_delete}</li>
      ;
    });
    return (
    <div className="admin-wrapper">
      <Helmet>
        <meta name="viewport" content="width=1360" />
        <title>30min. Admin Console</title>
      </Helmet>
      <div className="admin-header-side">
        <div className="header_title">
          <img src="/images/logo.png" className="logo" alt="logo" />
        </div>
        <ul className="global-menu">
          <Link to="/admin_users"><li className={ window.location.pathname === "/admin_users" ? "active" : "" }><FontAwesomeIcon icon={faUser} /></li></Link>
          <Link to="/admin_users_deleted"><li className={ window.location.pathname === "/admin_users_deleted" ? "active" : "" }><FontAwesomeIcon icon={faUserSlash} /></li></Link>
          <Link to="/admin_casts"><li className={ window.location.pathname === "/admin_casts" ? "active" : "" }><FontAwesomeIcon icon={faUserTie} /></li></Link>
          <Link to="/admin_reservations"><li className={ window.location.pathname === "/admin_reservations" ? "active" : "" }><FontAwesomeIcon icon={faBook} /></li></Link>
          {/* <Link to="/admin_payments"><li className={ window.location.pathname === "/admin_payments" ? "active" : "" }><FontAwesomeIcon icon={faMoneyBill} /></li></Link> */}
          <Link to="/admin_debug"><li className={ window.location.pathname === "/admin_debug" ? "active" : "" }><FontAwesomeIcon icon={faTools} /></li></Link>
        </ul>
      </div>
      <div className="admin-header-top">
        <div className={this.state.notifications.length === 0 ? "admin-notifications hide" : "admin-notifications"}>
          <ul className="admin-notification">
            {notification_list}
          </ul>
        </div>
        <div className="admin-user">
          <img src={"/images/" + this.state.email + ".png"} className="admin-user-icon" alt="" onClick={e => this.dropdown()} />
          <ul className={this.state.dropdownmenu === "hide" ? "dropdown-menu hide" : "dropdown-menu"}>
          	<li className="admin-profile"><span>Sign in as</span><br />{this.state.email}</li>
            <li onClick={this.rePassword}>パスワード変更</li>
            <li onClick={e => this.logout()}>ログアウト</li>
          </ul>
        </div>
      </div>
    </div>
    );  
  }
}